import { ChangeDetectionStrategy, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { debounceTime, Subject } from 'rxjs';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent implements OnInit, OnDestroy {

  @Output() valueChange = new EventEmitter<string>();
  searchControl = '';
  subject$ = new Subject<string>();

  ngOnInit(): void {
      this.subject$
        .pipe(
          debounceTime(1000)
        )
        .subscribe((searchText: string) => {
          this.valueChange.emit(searchText);
        });
  }

  ngOnDestroy(): void {
    this.subject$.unsubscribe();
  }

  emitValueChange() {
    this.subject$.next(this.searchControl);
  }

}
